import { requiredFields, initializedMissingFields } from '../constants/formConfig';

/**
 * Validate form fields and return missing fields state
 * @param {Object} formValue - Current form values
 * @param {Object} certificateState - Certificate checkbox states
 * @param {boolean} isEmailValid - Whether email is valid
 * @returns {Object} Missing fields state object
 */
export const validateFields = (formValue, certificateState, isEmailValid) => {
  return requiredFields.reduce((acc, field) => {
    if (field === 'certificate') {
      const checkedCertificate = Object.keys(certificateState).filter(key => certificateState[key]);
      if (checkedCertificate.length === 0) {
        acc[field] = true;
      } else if (checkedCertificate.includes('noEnglishScore')) {
        acc[field] = false;
      } else {
        acc[field] = checkedCertificate.filter(checkedC => !formValue[checkedC]).length > 0;
      }
    } else if (field === 'email') {
      acc[field] = !isEmailValid;
    } else if (formValue[field] === 'other' || formValue[field] === 'others') {
      const otherFieldName = `other${field.charAt(0).toUpperCase()}${field.slice(1)}`;
      acc[field] = !formValue[otherFieldName];
    } else {
      acc[field] = !formValue[field];
    }
    return acc;
  }, { ...initializedMissingFields });
};

/**
 * Check if a section is complete (all required fields filled)
 * Used for real-time progress tracking
 * @param {Object} section - Section config object
 * @param {Object} formValue - Current form values
 * @param {Object} certificateState - Certificate checkbox states
 * @param {boolean} emailValid - Whether email is valid
 * @returns {boolean} Whether section is complete
 */
export const isSectionComplete = (section, formValue, certificateState, emailValid) => {
  return section.fields.every(field => {
    if (field === 'certificate') {
      const checked = Object.keys(certificateState).filter(key => certificateState[key]);
      if (checked.length === 0) return false;
      if (checked.includes('noEnglishScore')) return true;
      return checked.every(c => formValue[c]);
    }
    if (field === 'email') return emailValid;
    const val = formValue[field];
    if (val === 'other' || val === 'others') {
      const otherField = `other${field.charAt(0).toUpperCase()}${field.slice(1)}`;
      return !!formValue[otherField];
    }
    return !!val;
  });
};
